import { ClientJS } from 'clientjs';

/**
 * 获取浏览器指纹
 * @returns 浏览器指纹
 */
export function getFingerprint(): number {
  const client = new ClientJS();
  return client.getFingerprint();
}

/**
 * 获取设备信息
 * @returns 设备信息对象
 */
export function getDeviceInfo() {
  return {
    userAgent: navigator.userAgent,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
  };
}
